import {useEffect, useState} from 'react';
import {UserClaims, getUserClaims} from '../services/getUserClaims';
import {useBookingState} from '../store';
import {pinUserClaim} from '../utils/constants';

export function useUserClaims() {
  const updatePersonProperty = useBookingState((state) => state.updatePersonProperty);
  const [userClaims, setUserClaims] = useState<UserClaims | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      let uc = await getUserClaims();
      if (!uc) {
        setLoading(false);
        return;
      }

      const personalIdentityNumber = uc?.[pinUserClaim] ?? '';
      setUserClaims({...uc, pinUserClaim: personalIdentityNumber});

      // Set Person 1 PIN in state
      updatePersonProperty(1, 'personalIdentityNumber', personalIdentityNumber);
      setLoading(false);
    };

    fetchData();
  }, []);

  return {
    userClaims,
    loading,
  };
}
